import { combineReducers } from 'redux';
import protocolDeviationsReducer from './deviations/protocolDeviationsReducer';

export const EmptyReducer = (state = null, action) => state;

export default history => combineReducers({
  empty: EmptyReducer,
  protocolDeviations: protocolDeviationsReducer
});
